<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

<salonmonster-tap-retry
  *ngIf="errorOccurred"
  (click)="loadPage()"
></salonmonster-tap-retry>

<mat-card *ngIf="!isLoading && !errorOccurred">
  <form [formGroup]="clientForm" (ngSubmit)="onClientSave()">
    <h2>{{ 'PROFILE.THANK_YOU' | translate }}</h2>
    <br />

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.FIRST_NAME' | translate }}</mat-label>
      <input
        matInput
        type="text"
        name="firstName"
        formControlName="firstName"
      />
      <mat-error *ngIf="firstName.hasError('required')">
        {{ 'PROFILE.FIRST_NAME_REQUIRED' | translate }}
      </mat-error>

      <mat-error *ngIf="firstName.hasError('maxlength')">
        {{ 'PROFILE.FIRST_NAME_MAXLENGTH' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.LAST_NAME' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'PROFILE.LAST_NAME' | translate"
        type="text"
        name="lastName"
        formControlName="lastName"
      />
      <mat-error *ngIf="lastName.hasError('maxlength')">
        {{ 'PROFILE.LAST_NAME_MAXLENGTH' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.SELECT_PRONOUN' | translate }}</mat-label>
      <mat-select
        [placeholder]="'PROFILE.SELECT_PRONOUN' | translate"
        name="pronouns"
        formControlName="pronouns"
      >
        <mat-option
          *ngFor="let pronoun of pronounOptions"
          [value]="pronoun.value"
        >
          {{ pronoun.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="pronouns.value == 4" appearance="outline">
      <mat-label>{{ 'PROFILE.CUSTOM_PRONOUNS' | translate }}</mat-label>
      <input
        matInput
        type="text"
        name="customerPronouns"
        formControlName="customerPronouns"
      />
      <mat-error *ngIf="email.hasError('maxlength')"
        >{{ 'PROFILE.CUSTOM_PRONOUNS_MAXLENGTH' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.EMAIL' | translate }}</mat-label>
      <input matInput type="email" name="email" formControlName="email" />
      <mat-error *ngIf="email.hasError('validateEmail')"
        >{{ 'PROFILE.EMAIL_INVALID' | translate }}</mat-error
      >
      <mat-error *ngIf="email.hasError('required')"
        >{{ 'PROFILE.EMAIL_REQUIRED' | translate }}</mat-error
      >
      <mat-error *ngIf="email.hasError('maxlength')"
        >{{ 'PROFILE.EMAIL_MAXLENGTH' | translate }}</mat-error
      >
      <mat-error *ngIf="email.hasError('clientEmailAvailability')"
        >{{ 'PROFILE.EMAIL_TAKEN' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.HOME_PHONE' | translate }}</mat-label>
      <input matInput type="tel" name="phone1" formControlName="phone1" />
      <mat-error *ngIf="phone1.hasError('maxlength')">
        {{ 'PROFILE.PHONE_MAXLENGTH' | translate }}
      </mat-error>
      <mat-error *ngIf="phone1.hasError('validatePhone')"
        >{{ 'PROFILE.PHONE_INVALID' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.MOBILE_PHONE' | translate }}</mat-label>
      <input matInput type="tel" name="phone2" formControlName="phone2" />
      <mat-error *ngIf="phone2.hasError('maxlength')">
        {{ 'PROFILE.PHONE_MAXLENGTH' | translate }}
      </mat-error>
      <mat-error *ngIf="phone1.hasError('validatePhone')"
        >{{ 'PROFILE.PHONE_INVALID' | translate }}</mat-error
      >
    </mat-form-field>
    <mat-error
      *ngIf="clientForm.hasError('atLeastOnePhoneRequired')"
      style="margin-bottom: 15px"
    >
      {{ 'PROFILE.PHONE_REQUIRED' | translate }}
    </mat-error>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.WORK_PHONE' | translate }}</mat-label>
      <input matInput type="tel" name="workPh" formControlName="workPh" />
      <mat-error *ngIf="workPh.hasError('maxlength')">
        {{ 'PROFILE.PHONE_MAXLENGTH' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.ADDRESS_1' | translate }}</mat-label>
      <input matInput type="text" name="address1" formControlName="address1" />
      <mat-error *ngIf="address1.hasError('maxlength')">
        {{ 'PROFILE.ADDRESS_MAXLENGTH' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.ADDRESS_2' | translate }}</mat-label>
      <input matInput type="text" name="address2" formControlName="address2" />
      <mat-error *ngIf="address2.hasError('maxlength')">
        {{ 'PROFILE.ADDRESS_MAXLENGTH' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.CITY' | translate }}</mat-label>
      <input matInput type="text" name="city" formControlName="city" />
      <mat-error *ngIf="city.hasError('maxlength')">
        {{ 'PROFILE.CITY_MAXLENGTH' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-list-item>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'PROFILE.PROVINCE' | translate }}</mat-label>
        <input
          matInput
          type="text"
          name="province"
          formControlName="province"
        />
        <mat-error *ngIf="province.hasError('maxlength')">
          {{ 'PROFILE.PROVINCE_MAXLENGTH' | translate }}
        </mat-error>
      </mat-form-field>
    </mat-list-item>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.POSTAL' | translate }}</mat-label>
      <input matInput type="text" name="postal" formControlName="postal" />
      <mat-error *ngIf="postal.hasError('maxlength')">
        {{ 'PROFILE.POSTAL_MAXLENGTH' | translate }}
      </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field appearance="outline">
      <mat-label>{{ 'PROFILE.SELECT_COUNTRY' | translate }}</mat-label>
      <mat-select
        [placeholder]="'PROFILE.SELECT_COUNTRY' | translate"
        name="country"
        formControlName="country"
      >
        <mat-option *ngFor="let country of countries" [value]="country.getID()">
          {{ country.getCountryName() }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div>
      <button
        mat-stroked-button
        secondaryButton
        sm-full-width
        (click)="viewChangePassword()"
      >
        {{ 'PROFILE.CHANGE_PASSWORD' | translate }}
      </button>
      <button mat-raised-button primaryButton sm-full-width type="submit">
        {{ saveButtonText }}
      </button>
    </div>
  </form>
</mat-card>
